import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiGet } from "../helpers/request.helpers";

export type Partner = {
  Id: string;
  Name: string;
  CreatedBy: number;
  CreationTime: string;
  CreatedByName: string;
};

export const partnersQueryOptions = queryOptions({
  queryKey: ["list-partners"],
  queryFn: async () => {
    const response = await apiGet("/list-partners");
    const partners: Partner[] = response.Partners;
    return partners;
  },
});

export function usePartners() {
  return useQuery(partnersQueryOptions);
}
